import './App.css';

function SupportUs() {
  return (
      <section className="contentSection">
        <div className="sectionHeading">
          <span className="sectionHeading__number">04</span>
          <div>
            <p className="eyebrow">Lobo Powerlifting</p>
            <h2>Support Us</h2>
          </div>
        </div>

        <div className="contentGrid">
          <article className="infoCard infoCard--accent">
            <p className="infoCard__label">01</p>
            <h3>Purchase T Shirts</h3>
            <p><a href="https://docs.google.com/forms/d/e/1FAIpQLSd9uxOMlXxh4QSHYinnc74W3EKou2kGoF_mQe5mNbHbAA6Zgw/viewform">Click here</a> to order T Shirts. A staff member will reach out to you for payment and delivery/pickup information.</p>
          </article>
          <article className="infoCard">
            <p className="infoCard__label">02</p>
            <h3>Donate</h3>
            <p>Coming soon.</p>
          </article>
        </div>
      </section>
  );
}

export default SupportUs;
